// extracted by mini-css-extract-plugin
export default {"tags":"Tags_tags__YFpl-","tooltip":"Tags_tooltip__Ded6k","column":"Tags_column__krrXA"};